// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Video_modalOverlay__dpGNz","modalContent":"Video_modalContent__MuX3H"};